"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getLoadingState = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _ILoading = require("../../models/ILoading");

var collapsedPrecedenceHierachy = new _map.default([[_ILoading.LoadingState.loaded, 0], [_ILoading.LoadingState.notLoaded, 1], [_ILoading.LoadingState.error, 2], [_ILoading.LoadingState.loading, 3], [_ILoading.LoadingState.paging, 4], [_ILoading.LoadingState.refreshing, 5]]);
var defaultLoadingState = _ILoading.LoadingState.loaded;
/** Gets an aggregate loading state based on an list of loadables */

var getLoadingState = function getLoadingState() {
  for (var _len = arguments.length, loadables = new Array(_len), _key = 0; _key < _len; _key++) {
    loadables[_key] = arguments[_key];
  }

  var isLoading = (0, _reduce.default)(loadables).call(loadables, function (isLoadingAccumulator, currentLoadable) {
    return !!(isLoadingAccumulator || currentLoadable && currentLoadable.isLoading);
  }, false);
  var loadingError = (0, _reduce.default)(loadables).call(loadables, function (loadingErrorAccumulator, currentLoadable) {
    return loadingErrorAccumulator || (currentLoadable ? currentLoadable.loadingError : undefined);
  }, undefined);
  var loadingState = (0, _reduce.default)(loadables).call(loadables, function (loadingStateAccumulator, currentLoadable) {
    if (currentLoadable !== null) {
      var accumulatedHierachy = collapsedPrecedenceHierachy.get(loadingStateAccumulator) || 0;
      var currentHierachy = collapsedPrecedenceHierachy.get(currentLoadable && currentLoadable.loadingState || defaultLoadingState) || 0;

      if (currentHierachy > accumulatedHierachy) {
        return currentLoadable.loadingState || defaultLoadingState;
      }
    }

    return loadingStateAccumulator;
  }, defaultLoadingState);
  var evaluatedLoadingState = isLoading && _ILoading.LoadingState.loading || loadingState;
  return {
    isLoading: isLoading,
    loadingError: loadingError,
    loadingState: evaluatedLoadingState
  };
};

exports.getLoadingState = getLoadingState;